import { createSlice } from '@reduxjs/toolkit';
import { LABELGENAPI} from '../../../API';
import { logFrontendActivity } from '../../General/activityLogger';
import { fetchProfile} from '../Profile/profileSlice';


export const labelsettingsslice = createSlice({
    name: 'labelSettings',
    initialState: {
        data: [],
        loading: false,
        hasErrors: false,
        message: ""
    },
    reducers: {
        getLabelData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        getLabelDataSuccess: (state, action) => {
            return {
                ...state,
                data: action && action.payload && action.payload.data && action.payload.data.data,
                hasErrors: false,
                loading: false
            }
        },
        getLabelDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.message
            }
        },
        
        postLabelData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        postLabelDataSuccess: (state, action) => {
            return {
                ...state,
                hasErrors: false,
                loading: false,
                message: action && action.payload && action.payload.data && action.payload.data.message
            }
        },
        postLabelDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.message
            }
        },
        deleteLabelData: (state) => {
            return {
                ...state,
                loading: true,
                hasErrors: false
            }
        },
        deleteLabelDataSuccess: (state, action) => {
            return {
                ...state,
                hasErrors: false,
                loading: false,
                message: action && action.payload && action.payload.data && action.payload.data.message
            }
        },
        deleteLabelDataFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.message
            }
        },
        resetlabel: (state) => {
            return {
                ...state,
                loading: false,
                hasError: false,
                message: "",
            }
        },


    }
})
export const { getLabelData, getLabelDataSuccess, getLabelDataFailure,  postLabelData, postLabelDataSuccess, postLabelDataFailure,
    deleteLabelData,deleteLabelDataSuccess,deleteLabelDataFailure,resetlabel } = labelsettingsslice.actions;

export const getLabel = data => dispatch => {
    dispatch(postLabelData());
    try {
        LABELGENAPI.get('/settings/label-settings')
            .then(function (response) {
                dispatch(getLabelDataSuccess(response));
            }).catch(function (error) {
                dispatch(getLabelDataFailure(error.response));
            })
    }
    catch (error) {
        dispatch(getLabelDataFailure(error.response));
    }
}
export const postlabel = (userid,label_format,logoDelete,data) => dispatch => {
    const object = {};
    if (data && typeof data.entries === 'function') {
        for (let [key, value] of data.entries()) {
            object[key] = value instanceof File ? value.name : value;
        }
    } else if (typeof data === 'object') {
        for (let [key, value] of Object.entries(data)) {
            object[key] = value instanceof File ? value.name : value;
        }
    } else {
        console.error('Unexpected data type:', typeof data);
    }
    dispatch(postLabelData());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI.post('/settings/label-settings?label_format=' + label_format+'&logo_remove='+logoDelete, data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(postLabelDataSuccess(response));
                dispatch(fetchProfile({ force: true }));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'LABEL',
                    action: 'SUCCESS',
                    request_data: object,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });  
                dispatch(getLabel());
            }).catch(function (error) {
                dispatch(postLabelDataFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'LABEL',
                    action: 'FAILURE',
                    request_data: object,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                }); 
            })
    }
    catch (error) {
        dispatch(postLabelDataFailure(error.response));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'LABEL',
            action: 'FAILURE',
            request_data: object,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}
export const deletelabel = (userid,data) => dispatch => {
    dispatch(deleteLabelData());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI.delete('/settings/label-settings')
            .then(function (response) {
                dispatch(deleteLabelDataSuccess(response));
                 logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'LABEL_DELETE',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            }).catch(function (error) {
                dispatch(deleteLabelDataFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'LABEL_DELETE',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });  
            })
    }
    catch (error) {
        dispatch(deleteLabelDataFailure(error.response));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'LABEL_DELETE',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}
export const resetLabelState = data => dispatch => {
    dispatch(resetlabel());
}

export default labelsettingsslice.reducer;
